export const pageNames = {
  track: "Track",
  artist: "Artist",
  general: "Search",
  album: "Album",
  playlist: "Playlist",
  recommendation: "Recommendations",
  user: "Home",
  browse: "Browse"
};